<template>
  <div class="mx-0 mx-lg-3 d-flex justify-content-between">
    <template v-for="(step, index) in props.steps" :key="index">
      <template v-if="(step.visible ?? true) && (step.active ?? true)">
        <div
          @click.prevent="(step.anchor || canNavigateToStep(index)) ? emits('onStepChanged', index, step) : null"
          :class="{'is-active': isCurrentStep(index)}"
          class="text-center mx-2 text-decoration-none text-reset d-flex flex-column align-items-center"
          style="width: 70px;"
          :role="(step.anchor || canNavigateToStep(index)) ? 'button' : undefined"
        >
          <span class="fa-stack fa-lg" style="vertical-align: top;height: 2.5em;line-height: 2.5em;">
            <i
              class=" fa-circle fa-stack-2x"
              :class="[
                currentStep >= index ? 'text-primary fa-regular' : 'text-secondary fa-solid text-opacity-25',
              ]"
              style="font-size: 2.5em;"></i>
            <i class="fa-stack-1x"
            :class="[
              step.icon,
              currentStep >= index ? 'text-primary' : 'text-secondary'
            ]"></i>
          </span>
          <div class="small"
            :class="[
            isCurrentStep(index) ? 'text-primary' : 'text-secondary'
          ]"
          style="padding: 0px 10px;max-width: 13vw;white-space: nowrap;overflow: hidden;">
          {{ step.stepTitle || step.title }}
          </div>
        </div>
        <div
          v-if="index < props.steps.length - 1 && (((props.steps[index + 1]?.visible ?? true) && (props.steps[index + 1]?.active ?? true)) || (index + 2) !== (props.steps.length))"
          class="flex-fill pt-2"
          :class="[currentStep > index ? 'text-primary' : 'text-secondary']"
        >
          <hr class="border-2 opacity-75">
        </div>
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  const step = defineModel<number | null>('step', { default: null });
  const emits = defineEmits<{
    (e: 'onStepChanged', index: number, step: StepperElement): void
  }>();

  const props = withDefaults(defineProps<{
    steps: StepperElement[],
    canNavigateToStep?: (index: number) => boolean
  }>(), {
    canNavigateToStep: () => false
  });


  const isCurrentStep = (index: number) => {
    return currentStep.value != null && currentStep.value === index;
  };

  const currentStep = computed(() => {
    return step.value != null ? Math.max(step.value, 0) : -1;
  });
</script>
